/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertFormHeaderComponent} from './alert-form-header.component';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [AlertFormHeaderComponent],
    exports: [AlertFormHeaderComponent],
    imports: [
        CommonModule,
        TooltipModule
    ]
})
export class AlertFormHeaderModule {
}
